import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { useGlobalQueries } from '@/exceed';

import {
  createLiveVideoEnrollment,
  createWaitlistItem,
  updateLiveVideoEnrollment,
} from '../api';

import getIsUserPublic from '../helpers/getIsUserPublic';

export default ({ isVideoFetching, refetchAgendaItems }) => {
  const [isSettingEnrollmentStatus, setIsSettingEnrollmentStatus] = useState(false);
  const { currentUser } = useGlobalQueries();
  const { id } = useParams();
  const queryClient = useQueryClient();

  const setEnrollmentStatus = async (action) => {
    if (getIsUserPublic({ currentUser })) return;

    const sessionId = queryClient.getQueryData(['video', id]).data.course_session_id;

    setIsSettingEnrollmentStatus(true);

    switch (action) {
      case 'drop':
        await updateLiveVideoEnrollment({ id, status: 'dropped' });
        break;
      case 'enroll':
        await createLiveVideoEnrollment({ id });
        await refetchAgendaItems();
        break;
      case 'joinWaitlist':
        await createWaitlistItem({ id: sessionId });
        break;
      case 'leaveWaitlist':
        // TODO: add api
        break;
      default:
    }

    queryClient.invalidateQueries({ queryKey: ['video', id] });
    setIsSettingEnrollmentStatus(false);
  };

  return {
    isSettingEnrollmentStatus: isVideoFetching || isSettingEnrollmentStatus,
    setEnrollmentStatus,
  };
};
